import type { ColumnDef, Table } from "@tanstack/react-table";
import type { IClienteHistorial } from "../../../modelos/ClientesContratos/entidades/IClienteHistorial";

// Formateador específico para la tabla de clientes: mantiene la lógica previa
// (tratar cadenas sin zona como UTC añadiendo 'Z').
export const formatearFechaClientes = (fecha: string | Date | number): string => {
  if (!fecha) return "";

  try {
    let fechaString = String(fecha);
    let fechaObjeto: Date;

    if (typeof fecha === 'string' && !fechaString.endsWith('Z')) {
      fechaObjeto = new Date(`${fechaString}Z`);
    } else {
      fechaObjeto = new Date(fecha);
    }

    const fechaFormateada = new Intl.DateTimeFormat("es-CO", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "America/Bogota",
    }).format(fechaObjeto);

    return fechaFormateada.replace(",", "");
  } catch (error) {
    console.error("Error formateando fecha (clientes):", error);
    return "";
  }
};

interface ColumnasTablaClienteParams {
  manejarEdicionCliente: (cliente: IClienteHistorial) => void;
  tabla: Table<IClienteHistorial>;
}

export const columnasTablaCliente = ({
}: ColumnasTablaClienteParams): ColumnDef<IClienteHistorial>[] => [
    { accessorKey: "Nombre", header: "Nombre Cliente" },
    { accessorKey: "TipoIdentificacion", header: "Tipo Identificación" },
    { accessorKey: "Identificacion", header: "Identificación" },
    { accessorKey: "RazonSocial", header: "RazonSocial" , cell: ({ row }) => row.original.RazonSocial || "-"  },
    { accessorKey: "FechaInicioAsignacionCliente", header: "Fecha Inicio", cell: ({ row }) => `${formatearFechaClientes(row.original.FechaInicioAsignacionCliente)}`  },
    { accessorKey: "FechaFinAsignacionCliente", header: "Fecha Fin", cell: ({ row }) => `${formatearFechaClientes(row.original.FechaFinAsignacionCliente)}`  },
  ];
